<footer class="beta-footer">
    <section class="main-footer">
        <div class="container-fluid wrap">
            <div class="row">
                <div class="col-xs-12 col-sm-4 col-md-2">
                    <div class="loga">World Health Organization</div>
                </div>
                <div class="col-xs-12 col-sm-8 col-md-10">
                <div class="btn-beta mb1">Beta Version</div>
                    <p><strong>This is a beta version of the platform.</strong> Content, features, and data may be subject to change. This environment will not be migrated to the official WHO website until after the validation period by end of July 2026</p>
                </div>
        </div>
    </section>
    <section class="under-footer">
        <div class="container-fluid wrap">
            <div class="flex middle-xs between-xs">
                <span>© 2026 WHO</span>
                <span>Not for public use</span>
            </div>
        </div>
    </section>
</footer>